module.exports = __webpack_public_path__ + "img/hir_no.b3be0d9b.png";